import {
  Box,
  TextField,
  Button,
  Typography,
  Link,
  InputLabel,
} from '@mui/material';
import { Formik, Form, FormikProps } from 'formik';
import '../../auth-dialog.scss';
import {
  UpdatePasswordFormValues,
  updatePasswordInitialValues,
  updatePasswordSchema,
} from '../../utils/form-validation.ts';

const labelStyle = {
  color: 'white',
  fontSize: '12px',
  marginBottom: '4px',
};

interface ResetPasswordNewPasswordFormProps {
  setActivePage: (value: string) => void;
  resetPassword: (value: UpdatePasswordFormValues) => void;
  postSubmitErrors: string;
  isPending: boolean;
  userId: string | undefined;
}

export const ResetPasswordNewPasswordForm = ({
  setActivePage,
  resetPassword,
  postSubmitErrors,
  isPending,
  userId,
}: ResetPasswordNewPasswordFormProps) => {
  return (
    <>
      <Typography
        sx={{ marginBottom: '12px', textAlign: 'center' }}
        data-testid="login-form"
      >
        A verification code has been sent to your email. Please, enter the code
        you received and a new password for your account.
      </Typography>
      <Formik
        initialValues={updatePasswordInitialValues}
        validationSchema={updatePasswordSchema}
        onSubmit={(values) => {
          resetPassword(values);
        }}
      >
        {({
          values,
          touched,
          errors,
          handleChange,
          isValid,
          dirty,
        }: FormikProps<UpdatePasswordFormValues>) => {
          return (
            <Form>
              <Box className="field-group">
                <Box className="field homeStylePreference">
                  <InputLabel sx={labelStyle}>Verification Code</InputLabel>
                  <TextField
                    fullWidth
                    className="text-input"
                    id="verificationCode"
                    name="verificationCode"
                    placeholder="Verification Code"
                    onChange={handleChange}
                    value={values.verificationCode}
                    error={
                      touched.verificationCode &&
                      Boolean(errors.verificationCode)
                    }
                    helperText={
                      touched.verificationCode && errors.verificationCode
                    }
                  />
                </Box>
              </Box>
              <Box className="field-group">
                <Box className="field homeStylePreference">
                  <InputLabel sx={labelStyle}>New Password</InputLabel>
                  <TextField
                    fullWidth
                    className="text-input"
                    id="newPassword"
                    type="password"
                    name="newPassword"
                    placeholder="New Password"
                    onChange={handleChange}
                    value={values.newPassword}
                    error={touched.newPassword && Boolean(errors.newPassword)}
                    helperText={touched.newPassword && errors.newPassword}
                  />
                </Box>
              </Box>
              <Box className="field-group">
                <Box className="field homeStylePreference">
                  <InputLabel sx={labelStyle}>Confirm New Password</InputLabel>
                  <TextField
                    fullWidth
                    className="text-input"
                    id="confirmNewPassword"
                    type="password"
                    name="confirmNewPassword"
                    placeholder="Confirm New Password"
                    onChange={handleChange}
                    value={values.confirmNewPassword}
                    error={
                      touched.confirmNewPassword &&
                      Boolean(errors.confirmNewPassword)
                    }
                    helperText={
                      touched.confirmNewPassword && errors.confirmNewPassword
                    }
                  />
                </Box>
              </Box>
              <Button
                disabled={isPending || !isValid || !dirty}
                type="submit"
                sx={{ minWidth: '100%' }}
              >
                Reset Password
              </Button>
              {!userId && (
                <Link
                  data-testid="reset-password-link"
                  sx={{
                    color: 'white',
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: '12px',
                  }}
                  onClick={() => setActivePage('login')}
                  href="#"
                  className="forgot-password-link"
                >
                  Back to sign in{' '}
                </Link>
              )}
              {postSubmitErrors && (
                <Box sx={{ marginTop: '12px' }}>
                  <Typography sx={{ borderBottom: 'solid 1px white' }}>
                    Something's wrong:{' '}
                  </Typography>
                  <ul>
                    <li>{postSubmitErrors}</li>
                  </ul>
                </Box>
              )}
            </Form>
          );
        }}
      </Formik>
    </>
  );
};
